import { Children, type ReactNode } from 'react';
import { StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { spacing, unisonColors } from '@/theme';

const ACTION_GAP = 8;
const ACTION_HEIGHT = 48;

export interface ActionFooterBarProps {
  readonly children: ReactNode;
  readonly testID?: string;
}

export const ActionFooterBar = ({ children, testID }: ActionFooterBarProps) => {
  const actions = Children.toArray(children);
  const actionTestIdPrefix = testID ?? 'action-footer-bar';
  const { bottom } = useSafeAreaInsets();

  return (
    <View style={[styles.safeArea, { paddingBottom: Math.max(bottom, spacing[2]) }]}>
      <View style={styles.container} testID={testID}>
        {actions.map((action, index) => (
          <View
            key={`action-${index}`}
            style={styles.action}
            testID={`${actionTestIdPrefix}-action-${index}`}>
            {action}
          </View>
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  safeArea: {
    backgroundColor: unisonColors.white,
  },
  container: {
    // Stretch so a wrapped label does not leave the actions at different heights.
    alignItems: 'stretch',
    columnGap: ACTION_GAP,
    flexDirection: 'row',
    paddingHorizontal: spacing[3],
    paddingVertical: spacing[2],
  },
  action: {
    flex: 1,
    justifyContent: 'center',
    minHeight: ACTION_HEIGHT,
  },
});
